import React from "react";
import { Link } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import {
  getAchievementImage,
  getAchievementPath,
} from "../cms/achievements";
import { useCmsAchievements, useCmsPage } from "../cms/useCmsContent";

export default function AchievementsPage() {
  const { content } = useCmsPage("realisations");
  const { achievements } = useCmsAchievements();
  const sections = content.sections || {};
  const hero = sections.hero || {};
  const cta = sections.cta || {};

  return (
    <main>
      <section className="missions-hero">
        <div className="container">
          <div className="missions-hero-copy">
            <p className="section-kicker mb-3">
              {hero.kicker || "Toutes les missions"}
            </p>
            <h1 className="section-heading mb-4">
              {hero.title ||
                "Des réalisations vérifiables pour comprendre notre manière d'intervenir."}
            </h1>
            <p>
              {hero.description ||
                "Chaque mission présente le contexte, l'approche et les résultats obtenus afin de vous aider à vous projeter avant le premier échange."}
            </p>
          </div>
        </div>
      </section>

      <section className="container py-7">
        <div className="missions-list">
          {achievements.map((achievement) => (
            <article className="mission-list-card" key={achievement._id || achievement.title}>
              <Link className="mission-list-media" to={getAchievementPath(achievement)}>
                <img src={getAchievementImage(achievement)} alt={achievement.title} />
              </Link>
              <div className="mission-list-body">
                <div className="achievement-meta">
                  {[achievement.category, achievement.country, achievement.year]
                    .filter(Boolean)
                    .join(" · ")}
                </div>
                <h2>
                  <Link to={getAchievementPath(achievement)}>{achievement.title}</Link>
                </h2>
                <p>{achievement.description}</p>
                {achievement.metrics?.length > 0 && (
                  <div className="mission-list-metrics">
                    {achievement.metrics.slice(0, 3).map((metric) => (
                      <span key={`${achievement.title}-${metric.value}-${metric.label}`}>
                        <strong>{metric.value}</strong>
                        {metric.label}
                      </span>
                    ))}
                  </div>
                )}
                <Link className="mission-detail-link" to={getAchievementPath(achievement)}>
                  Consulter la mission <RiArrowRightLine aria-hidden="true" />
                </Link>
              </div>
            </article>
          ))}
        </div>

        <div className="content-panel p-4 p-lg-5 mt-6 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-4">
          <div>
            <p className="section-kicker mb-2">
              {cta.kicker || "Vous avez un besoin similaire ?"}
            </p>
            <h2 className="h3 fw-bold mb-0">
              {cta.title || "Parlons de votre mission et des résultats attendus."}
            </h2>
          </div>
          <Link to="/contact" className="btn btn-success">
            {cta.button || "Qualifier ma demande"}
          </Link>
        </div>
      </section>
    </main>
  );
}
